var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 13L37 13L37 39L11 39L11 13Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    id: "Ellipse",
    fill: "#0D9C7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13L37 13L37 39L11 39L11 13Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_9_Monitor",
    transform: "translate(11 15.524902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9363 19.71L16.9821 19.71C16.347 19.1177 15.9322 18.4405 15.6747 17.738L10.3281 17.738C10.0707 18.4405 9.6558 19.1177 9.02078 19.71L8.06711 19.71C7.52848 19.71 7.09186 20.1466 7.09186 20.6852C7.09186 20.8317 7.21058 20.9505 7.35709 20.9505L18.6465 20.9505C18.7929 20.9505 18.9117 20.8317 18.9117 20.6852C18.9116 20.1467 18.4749 19.71 17.9363 19.71L17.9363 19.71Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8328 1.93715e-07L1.17 1.93715e-07C0.597441 1.93715e-07 0 0.461907 0 1.17L0 15.9983C0 16.6538 0.53102 17.1849 1.18661 17.1849L24.8327 17.1849C25.4827 17.1849 26 16.6621 26 16.0177L26 1.17C25.9999 0.525535 25.4827 0 24.8328 0L24.8328 1.93715e-07ZM12.6847 16.2998C12.397 16.2998 12.1647 16.0674 12.1647 15.7798C12.1647 15.4921 12.397 15.2598 12.6847 15.2598C12.9723 15.2598 13.2074 15.4921 13.2074 15.7798C13.2074 16.0675 12.9723 16.2998 12.6847 16.2998L12.6847 16.2998ZM24.617 14.3747L1.383 14.3747L1.383 1.38293L24.617 1.38293L24.617 14.3746L24.617 14.3746L24.617 14.3747Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.48C16.2776 12.48 19.0823 9.8108 20.233 8.53848C20.5731 8.16234 20.5731 7.59252 20.233 7.21633C19.0823 5.94401 16.2776 3.27759 13 3.27759C9.72235 3.27759 6.91765 5.94401 5.76421 7.21633C5.42397 7.59247 5.42397 8.16229 5.76421 8.53848C6.91765 9.8108 9.72235 12.48 13 12.48L13 12.48ZM13 4.25952C14.9998 4.25952 16.6179 5.87756 16.6179 7.87738C16.6179 9.8772 14.9998 11.4952 13 11.4952C11.0002 11.4952 9.38214 9.8772 9.38214 7.87738C9.38214 5.87756 11.0002 4.25952 13 4.25952L13 4.25952Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9.8883C14.1119 9.8883 15.0109 8.98937 15.0109 7.87741C15.0109 7.64235 14.9666 7.41551 14.8947 7.20801C14.7398 7.48457 14.4466 7.67271 14.1064 7.67271C13.6085 7.67271 13.2047 7.26885 13.2047 6.77104C13.2047 6.43086 13.3928 6.13765 13.6694 5.98276C13.462 5.91086 13.2352 5.86658 13 5.86658C11.8881 5.86658 10.9891 6.76551 10.9891 7.87746C10.9891 8.98942 11.8881 9.8883 13 9.8883L13 9.8883Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.e6bd592617ef9f6bd1880f96117e875b.svg";
export { ForwardRef as ReactComponent };